module.exports = __webpack_public_path__ + "img/c41f6748cedc533b50e9361f124c3e17.280d102c.jpg";